import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CreditProposalResult } from '../../../interfaces/CreditProposalInterface/CreditProposalInterface';

interface CreditProposalData {
  data: CreditProposalResult | null;
}

const initialState: CreditProposalData = {
  data: null,
};

export const creditProposalSlice = createSlice({
  name: 'proposal',
  initialState,
  reducers: {
    saveCreditProposal: (state, action: PayloadAction<CreditProposalResult>) => {
      state.data = action.payload;
    },
  },
});

export const { saveCreditProposal } = creditProposalSlice.actions;

export default creditProposalSlice.reducer;
